<template lang="html">
    <section class="orders-information">
        <figure class="store-img"><img src="http://rem3rch-back.snap.viseo.com/uploads/components/small/20171004004437470.jpg" /></figure>
        <div class="store-contact">
            <div class="store store-adress">
                <span class="label label-region">Champs elysees</span> <span class="label">125 avenue des champs elysees</span>
                <span class="label label-country">France</span>
            </div>
            <div class="store store-phone"><span>+44 0376 124578</span></div>
            <div class="store store-status"><span class="label">Store status:</span> <span>Approved</span></div>
            <div class="store store-email"><span class="label">Contact:</span> <span class="email">toto.tata@gmail.com</span></div>
            <div class="store store-type"><span class="label">Display type: </span> <span>Hybrid 5 bays</span></div>
            <div class="store-action"><button class="btn-orders">view planogram</button></div>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'orders-information',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes.scss";
.orders-information {
    line-height: 18px;
    @extend %primary-text;
    & span {
        text-transform: none;
    }
    & .label {
        font-size: 14px;
        font-family: "oswald-regular", sans-serif;
        text-transform: uppercase;
        &-region {
            font-weight: bold;
            display: block;
        }
        &-country {
            display: block;
        }
    }
    & .store {
        margin-bottom: 10px;
        &-img {
            text-align: center;
        }
        &-action {
            text-align: center;
            margin-top: 20px;
            & button {
                width: 80%;
                text-transform: uppercase;
            }
        }
        &-contact {
            margin-top: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// order-information.vue?24667bc6